import { writable } from 'svelte/store';

export const bindList = writable({});